export const GET_BALANCE = 'GET_BALANCE';
export const USER_IS_VERIFIED = 'USER_IS_VERIFIED';
export const NET_BANKING_OPTIONS = 'NET_BANKING_OPTIONS';
export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const APPLY_PROMO_CODE = 'APPLY_PROMO_CODE';
export const VALIDATE_PROMO_CODE = 'VALIDATE_PROMO_CODE';
export const APPLY_FREE_FUND_CODE = 'APPLY_FREE_FUND_CODE';
export const RESET_PROMO_CODE = 'RESET_PROMO_CODE';
export const RESET_FREE_FUND_CODE = 'RESET_FREE_FUND_CODE';
export const ADDMONEY_INIT = 'ADDMONEY_INIT';
export const CARD_BINS = 'CARD_BINS';

export const TOGGLE_PROMO_CODE = 'TOGGLE_PROMO_CODE';
export const TOGGLE_FREEFUND_CODE = 'TOGGLE_FREEFUND_CODE';

export const GET_WITHDRAW_FEE = 'GET_WITHDRAW_FEE';
export const DELETE_WITHDRAW_FEE = 'DELETE_WITHDRAW_FEE';
export const SELECT_BANK_ACCOUNT = 'SELECT_BANK_ACCOUNT';
export const WITHDRAW_SUCCESS = 'WITHDRAW_SUCCESS';